import styled from 'styled-components'

export const NotificationIcon = styled.span`
  display: flex;
  align-self: center;
  padding: 1rem;
  border-radius: 50%;
  background-color: var(--success500);
`

export const ConfirmDialogContent = styled.section`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`
